module.exports = __webpack_public_path__ + "img/Aura_soap.f599ceaa.png";